import { PaginationDTO, PaginationParams, ResponseDTO, PointsHistoryDTO } from '@/types';
import request from '@/utils/request';

/**
 * 用户积分信息
 */
export interface UserPointsDTO {
  /** 当前积分 */
  balance: number;
}

/**
 * 获取用户当前积分
 * @returns 用户积分信息
 */
export function getAccountPoints(): Promise<UserPointsDTO> {
  return request
    .get<UserPointsDTO, ResponseDTO<UserPointsDTO>, void>('/points/account')
    .then((res) => res.data);
}

/**
 * 获取用户积分变更历史
 * @returns 用户积分变更历史
 */
export function getPointsHistory(
  params: PaginationParams,
): Promise<PaginationDTO<PointsHistoryDTO>> {
  return request
    .get<PointsHistoryDTO[], ResponseDTO<PaginationDTO<PointsHistoryDTO>>, PaginationParams>(
      '/points/history',
      {
        params,
      },
    )
    .then((res) => res.data);
}
